import Vue from "vue"
import VueRouter from 'vue-router'
import VueWaypoint from 'vue-waypoint'
import { Chrome } from 'vue-color'
import veeno from 'veeno'
import { VueHammer } from 'vue2-hammer'
import SectionPage from './components/SectionPage'
import VoerroTagsInput from '@voerro/vue-tagsinput'

import router from './router'
import App from "./layout/App.vue"

Vue.use(VueRouter)
Vue.use(VueWaypoint)
Vue.use(VueHammer)

Vue.component('SectionPage', SectionPage)
Vue.component('ChromePicker', Chrome)
Vue.component('slider', veeno)
Vue.component('tags-input', VoerroTagsInput)

import 'nouislider/distribute/nouislider.min.css';

const vm = new Vue({
  render (h) {
    return h(App)
  },
  router
})

window.bc = new BroadcastChannel('test_channel');
vm.$mount("#app")

// JS RESET NO ZOOM & DOUBLE TAP
document.documentElement.addEventListener('touchstart', function (event) {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}, { passive: false }, false);

var lastTouchEnd = 0;
document.documentElement.addEventListener('touchend', function (event) {
  var now = (new Date()).getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, { passive: false }, false);

document.addEventListener('mousewheel', function(event) {
  if(event.ctrlKey) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, { passive: false }, false);